import { api } from '../api';

export interface CodigoPostalDto {
  codigo: string;
  localidad: string;
  provincia: string;
}

/**
 * Typeahead de códigos postales. Si `q` es numérico el backend hace prefix
 * match sobre el código; si es texto, busca por localidad. Devuelve hasta
 * `limit` resultados (default 20).
 */
export async function buscarCodigosPostales(q: string, limit = 20): Promise<CodigoPostalDto[]> {
  const query = (q ?? '').trim();
  if (!query) return [];
  const { data } = await api.get<CodigoPostalDto[]>('/codigos-postales/search', {
    params: { q: query, limit },
  });
  return data;
}
